import { ErrorTaskItemData, AddTaskType, InstanceProps } from './types';

class ErrorCatch {
  addTask?: AddTaskType;

  constructor(props: InstanceProps) {
		this.addTask = props.addTask;
	}

  /**
   * 错误捕获的方法
   */
  public init = () => {
    // JsError
    window.onerror = (message: string | Event, source?: string, line?: number, col?: number, error?: Error) => {
      // console?.error?.('---monitor-JsError---', message, source, line, col, error);
      const jsErrorInfo: ErrorTaskItemData = {
        type: 'js',
        message: message as string, // 报错信息
        fileName: source || '', // 文件名
        lineNumber: line || 0, // js报错文件的行号
        colNumber: col || 0, // js报错文件的列好
        stack: error?.stack || '', // 堆栈
      }
      this.traceInfo(jsErrorInfo);
    }

    // AjaxError
    if (window.XMLHttpRequest) {
      window.addEventListener('xhrReadyStateChange', this.catchAjaxError)
    }

    // PromiseError
    window.addEventListener('unhandledrejection', this.catchPromiseError)

    // ResourceError
    window.addEventListener('error', this.catchResourceError)
  }

  /**
   * 销毁错误捕获注册的事件监听
   */
  public destroy = () => {
    // JsError
    window.onerror = null;

    // AjaxError
    if (window.XMLHttpRequest) {
      window.removeEventListener('xhrReadyStateChange', this.catchAjaxError)
    }

    // PromiseError
    window.removeEventListener('unhandledrejection', this.catchPromiseError)

    // ResourceError
    window.removeEventListener('error', this.catchResourceError)
  }

  catchAjaxError = (event: any) => {
    // console?.error?.('---monitor-AjaxErrorr---', event);
    const detail = event.detail;
    if (detail.readyState !== 4 || (detail.status !== 0 && detail.status < 400)) return;

    const ajaxErrorInfo: ErrorTaskItemData = {
      type: 'ajax',
      message: `status: ${detail.status}; statusText: ${detail.statusText};`, // 报错信息
      fileName: detail.getRequestConfig?.[1] || '', // 文件名
      stack: detail.responseText || '', // 堆栈
    }
    this.traceInfo(ajaxErrorInfo);
  }

  catchPromiseError = (event: any) => {
    // console?.error?.('---monitor-PromiseError---', event);
    // isAxiosError 走request的api报错
    if (!event || !event.reason || event.reason.isAxiosError) return;

    const promiseError: ErrorTaskItemData = {
      type: 'promise',
      message: event.reason?.message || '', // 报错信息
      fileName: event.reason?.fileName || '', // 报错文件名
      stack: event.reason?.stack || '',
    }
    this.traceInfo(promiseError);
  }

  catchResourceError = (event: any) => {
    // console?.error?.('---monitor-ResourceError---', event);
    if (!event) return;

    const target: any = event.target || event.srcElement;
    const isElementTarget =
      target instanceof HTMLScriptElement ||
      target instanceof HTMLLinkElement ||
      target instanceof HTMLImageElement;

    // 不是ElementTarget 走js error 
    if (!isElementTarget) return;

    const resourceError: ErrorTaskItemData = {
      type: 'resource',
      message: event.message || event.error?.message || '', // 报错信息
      fileName: event.fileName || '', // 报错文件名
      stack: event.error?.stack || '', // 堆栈
    }
    this.traceInfo(resourceError);
  }

  /**
   * 错误上报的方法
   */
  public traceInfo = (info: ErrorTaskItemData) => {
    this.addTask?.('error', info);
  }
}

export default ErrorCatch;